import Base from "./base.js"
export default class Share extends Base {
  constructor() {
    super("share")
  }
}
